import { useSelector, useDispatch } from 'react-redux';
import { useGetMyProductsQuery } from '../features/products/productsApiSlice';
import { selectMyProducts, loadMyStore } from '../features/products/productSlice';
import useAuth from './useAuth';

const useMyProduct = () => {
  const dispatch = useDispatch();
  const { id } = useAuth();
  
  // Get products from Redux store
  const myProducts = useSelector(selectMyProducts);
  
  // Fetch products if not in store
  const { 
    data: fetchedProducts,
    isLoading,
    isError,
    error,
    isSuccess
  } = useGetMyProductsQuery(id, {
    skip: Array.isArray(myProducts) && myProducts.length > 0
  });

  // Load products into store if fetched successfully
  if (isSuccess && fetchedProducts && (!Array.isArray(myProducts) || myProducts.length === 0)) {
    dispatch(loadMyStore(fetchedProducts));
  }

  return {
    myProducts: Array.isArray(myProducts) ? myProducts : (fetchedProducts || []),
    isLoading,
    isError,
    error,
    isSuccess
  };
};

export default useMyProduct; 